module.exports = __webpack_public_path__ + "media/tape-nav/commerce-influencer-profile-44700953.svg";